<template>
  <div class="CertificateDialog" v-if="show">
    <CgModalMiddle :is-show-close="false">
      <i
        slot="modal_close"
        class="iconfont icon-cha"
        @click="show = false"
      />
      <div slot="modal_content" class="modal_content">

        <!-- 线上版 -->
        <template v-if="type == 1">
          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/1@1-1-1.jpg?v=2" alt="线上版1">
          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/1@2-1-1.jpg?v=2" alt="线上版2">
          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/1@3-1-1.jpg?v=2" alt="线上版3">
        </template>

        <!-- 基础版 -->
<!--        <template>-->
<!--          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/2@21_1.jpg?v=2" alt="基础版1">-->
<!--          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/2@22_1.jpg?v=2" alt="基础版2">-->
<!--          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/2@23_1.jpg?v=2" alt="基础版3">-->
<!--        </template>-->

        <template v-if="type == VIP_MANAGE.COMPANY.BASIC_100.ID">
          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/A_1.jpg?v=88" alt="升级版1">
          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/A_2.jpg?v=88" alt="升级版2">
          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/A_3.jpg?v=88" alt="升级版3">
        </template>

<!--        <template v-if="type == VIP_MANAGE.COMPANY.All_PURPOSE.ID">-->
<!--          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/A_1.jpg?v=5" alt="升级版1">-->
<!--          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/A_2.jpg?v=5" alt="升级版2">-->
<!--          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/A_3.jpg?v=5" alt="升级版3">-->
<!--        </template>-->

        <!-- 升级版 -->
        <template v-if="type == VIP_MANAGE.COMPANY.BASIC.ID">
          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/BASIC_1.jpg?v=5" alt="升级版1">
          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/BASIC_2.jpg?v=5" alt="升级版2">
          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/BASIC_3.jpg?v=5" alt="升级版3">
        </template>

        <!-- 升级版 -->
        <template v-if="type == VIP_MANAGE.COMPANY.All_PURPOSE.ID">
          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/B_1.jpg?v=88" alt="升级版1">
          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/B_2.jpg?v=88" alt="升级版2">
          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/B_3.jpg?v=88" alt="升级版3">
        </template>

        <!-- 专业版 -->
        <template v-if="type == VIP_MANAGE.COMPANY.MAJOR.ID">
          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/D_1.jpg?v=2" alt="专业版1">
          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/D_2.jpg?v=2" alt="专业版2">
          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/D_3.jpg?v=2" alt="专业版3">
        </template>

        <!-- 转售版 -->
        <template v-if="type == VIP_MANAGE.COMPANY.RELEASE.ID">
          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/E_1.jpg?v=2" alt="转售版1">
          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/E_2.jpg?v=2" alt="转售版2">
          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/E_3.jpg?v=2" alt="转售版3">
        </template>


        <!-- 大型企业线上版 -->
<!--        <template v-if="type == 10">-->
<!--          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/10@1-1-1.jpg?v=2" alt="大型企业线上版">-->
<!--          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/10@2-1-1.jpg?v=2" alt="大型企业线上版">-->
<!--          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/10@3-1-1.jpg?v=2" alt="大型企业线上版">-->
<!--        </template>-->


        <!-- 大型企业线下版 -->
<!--        <template v-if="type == 11">-->
<!--          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/11@1-1-1.jpg?v=2" alt="大型企业线下版">-->
<!--          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/11@2-1-1.jpg?v=2" alt="大型企业线下版">-->
<!--          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/11@3-1-1.jpg?v=2" alt="大型企业线下版">-->
<!--        </template>-->


        <!-- 多甲方授权版 -->
        <template v-if="type == 13">
          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/12@1-1-1.jpg?v=2" alt="多甲方授权版">
          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/12@2-1-1.jpg?v=2" alt="多甲方授权版">
          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/12@3-1-1.jpg?v=2" alt="多甲方授权版">
        </template>

        <!-- 医美行业专业版 -->
        <template v-if="type == 12">
          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/13@1-1-1.jpg?v=2" alt="医美行业专业版">
          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/13@2-1-1.jpg?v=2" alt="医美行业专业版">
          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/13@3-1-1.jpg?v=2" alt="医美行业专业版">
        </template>


        <!--  多张购买 -->
        <!-- 基础版 -->
        <template v-if="type == 31">
          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/31@1.jpg?v=2" alt="基础版">
          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/31@2.jpg?v=2" alt="基础版">
          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/31@3.jpg?v=2" alt="基础版">
          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/31@4.jpg?v=2" alt="基础版">
        </template>


        <!-- 专业版 -->
        <template v-if="type == 32">
          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/32@1.jpg?v=2" alt="专业版">
          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/32@2.jpg?v=2" alt="专业版">
          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/32@3.jpg?v=2" alt="专业版">
          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/32@4.jpg?v=2" alt="专业版">
        </template>


        <!-- 旗舰版 -->
        <template v-if="type == 33">
          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/33@1.jpg?v=2" alt="旗舰版">
          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/33@2.jpg?v=2" alt="旗舰版">
          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/33@3.jpg?v=2" alt="旗舰版">
          <img src="//static.588ku.com/chaotu/introduce/company/Certificate/33@4.jpg?v=2" alt="旗舰版">
        </template>


      </div>
    </CgModalMiddle>
  </div>
</template>

<script>
import {VIP_MANAGE} from "@/constant/VIP_MANAGE";

export default {
  name: "CertificateDialog",
  props: {
    type: {
      type: Number | String,
      default: 1
    }
  },
  data() {
    return {
      show: false,
      VIP_MANAGE
    }
  }
}
</script>

<style lang="scss" scoped>
.CertificateDialog {

  .icon-cha {
    transition: transform 0.5s ease-out;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    display: inline-block;
    font-size: 30px;
    color: #FFFFFF;
    cursor: pointer;
    @include Position(1, 2, -80px, 10px);
    z-index: 10000;


    &:hover {
      transform: rotateZ(180deg);
    }
  }


  .modal_content {
    width: 700px;
    height: 600px;
    background-color: #fff;
    border-radius: 14px;
    overflow-y: scroll;
    position: relative;

    img {
      display: inline-block;
      width: 100%;
    }


  }
}
</style>
